var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "social-linkedin_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 6v14.79h14.727V6zm0 18.488V59h14.727V24.488zm19.636 0h17.182c9.49 0 17.182 7.726 17.182 17.256V59H44.273V44.21c0-2.724-2.198-4.93-4.91-4.93V59H24.637z",
    clipRule: "evenodd"
  })));
};
export { SvgSocialLinkedin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUgNlYyMC43OTA3SDE5LjcyNzNWNkg1Wk01IDI0LjQ4ODRWNTlIMTkuNzI3M1YyNC40ODg0SDVaTTI0LjYzNjQgMjQuNDg4NEg0MS44MTgyQzUxLjMwNzUgMjQuNDg4NCA1OSAzMi4yMTQgNTkgNDEuNzQ0MlY1OUg0NC4yNzI3VjQ0LjIwOTNDNDQuMjcyNyA0MS40ODYzIDQyLjA3NDkgMzkuMjc5MSAzOS4zNjM2IDM5LjI3OTFWNTlIMjQuNjM2NFYyNC40ODg0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";